<template>
  <div class="privacy-policy">
    <div class="policy-container">
      <header class="policy-header">
        <h1>中碳普惠云AI服务用户协议</h1>
        <div class="policy-dates">
          <time>更新日期：2026年10月12日</time>
          <time>生效日期：2026年08月01日</time>
        </div>
      </header>

      <main>
        <!-- 各章节使用section包装 -->
        <section class="policy-section">
          <h2>协议概述</h2>
          <p>
            欢迎您使用中碳普惠云AI产品及/或服务！我们将严格遵守法律法规要求采取相应的安全保护措施，致力于确保用户信息及隐私的安全性。
          </p>
          <p>
            在使用本平台及服务前，请阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的条款，并选择接受或不接受本协议。本协议可由开发者随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在平台中查阅最新版协议条款。
          </p>
          <p>
            如果您无法准确理解或不同意本协议的任一内容，请暂时不要使用本服务。当您通过网络页面点击确认、勾选等方式同意本协议或实际使用本服务时，均表示您与我们已就本协议达成一致，同意受本协议约束。您同意本政策表示您已了解我们提供的产品及/或服务，以及相应产品及/或服务功能运行所需的必要用户信息（请特别注意，本政策所述用户信息可能包含企业/个人信息及/或敏感企业/个人信息，以下不再赘述），并给予相应的收集使用授权。
          </p>
          <p>
            如您未满18周岁，或因智力、精神健康状况等不具有完全民事行为能力，请在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用本服务。
          </p>
          <p>
            如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
          </p>
        </section>

        <section class="policy-section">
          <h2>定义与解释</h2>
          <p>除非上下文另有约定，下列词语具有如下含义：</p>
          <p>
            【我们/平台】指中碳普惠云科技有限公司及其关联公司运营的中碳普惠云AI服务平台。
          </p>
          <p>【用户/您】指注册、登录、使用本服务的个人或组织。</p>
          <p>
            【输入】指您在使用本服务过程中向平台提交的文字、语音、图片或其他格式的信息。
          </p>
          <p>
            【输出/生成内容】指平台基于您的输入，通过人工智能模型计算推理后输出的响应内容。
          </p>
          <p>【服务】指我们通过本平台向您提供的各项人工智能产品及/或服务。</p>
        </section>

        <section id="service" class="policy-section">
          <h2>一、服务内容</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>1.1 服务对象</h3>
              <div class="content-box">
                <p>
                  本服务的适用人群范围为具备完全民事行为能力的成年人（自然人），该范围与我们向国家网信部门备案登记的信息保持一致；如您属于未成年人或因智力、精神健康状况等不具备完全民事行为能力，请在法定监护人同意和指导下使用本服务。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.2 服务适用场合与用途</h3>
              <div class="content-box">
                <p>
                  本服务适用于用户为个人学习、研究、欣赏、日常生活、娱乐等非专业决策性场景使用。请勿在未经人工审核的情况下，将涉及个人的输出内容用于可能对该人产生法律或实质性影响的决策场景，包括但不限于信贷、教育、雇佣、住房、保险、法律、医疗等重大事项决策。
                </p>
                <p>
                  用户不得在无相应职业资格或服务资质的前提下，利用本服务提供须由专业人士给出的建议。
                </p>
                <p>
                  本服务基于大语言模型等人工智能技术，向用户提供智能问答、信息检索与整理、专业方案生成、碳核算与报告生成等专业领域人工智能服务，用于辅助用户提升信息获取与内容生产效率。具体服务功能以本协议 1.3、1.4 条及平台实际提供的功能为准。
                </p>
                <p>
                  本服务输出内容仅供参考，不可替代专业医疗、法律、金融、教育等领域的专业意见。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.3 基本服务</h3>
              <div class="content-box">
                <p>
                  我们以大模型为基础，向用户提供各项人工智能服务。模型基于用户输入信息（以下称"输入"），通过计算推理等输出相应的内容作为响应（以下称"输出"、"生成内容"）。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.4 服务功能</h3>
              <div class="content-box">
                <p>
                  我们的产品和服务的正常使用依赖于您输入的内容，因此我们需要收集并使用您输入的文字、语音、图片或其他格式的文件，从而为您提供对话服务。
                </p>
                <p>
                  关于信息收集的具体范围、收集方式、数量、用途及保存期限等详细信息，请参阅我们的<span
                    class="bold-text"
                    >《隐私政策》</span
                  >。本协议与《隐私政策》共同构成您使用本服务的完整约定。
                </p>
                <p>
                  为实现并保证体验的连续性，我们需要保存并处理您的历史对话信息。您可以随时删除您的历史对话信息。
                </p>
                <p>
                  您上传任何内容（包括但不限于正常输入、反馈或联系我们时提供的文字、语音、图片或其他格式的文件）时，请特别留意这些内容是否包含或涉及任何第三方的个人/企业信息或者涉密信息等不适当的信息。这包括但不限于姓名、联系方式或其他个人识别信息。在提交此类信息前，您有责任确保已经获得了所有必要的合法授权，以避免无意中泄露他人隐私或者侵犯其合法权益。
                </p>
                <p>
                  希望您理解，根据个人信息保护法的规定，下列情形无需事先获得您的同意：
                </p>
                <p>
                  (1)为订立、履行合同所必需：当您与我们订立或履行合同时，可能需要处理您的个人信息，例如为了完成交易或提供服务。
                </p>
                <p>
                  (2)为履行法定职责或者法定义务所必需：当我们需要遵守法律法规，履行法定职责或义务时，可能需要处理您的个人信息，例如与国家安全、刑事侦查、审判和执行等有关的或响应政府部门指示所必需。
                </p>
                <p>
                  (3)为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需：在紧急情况下，为了保护您或他人的生命、健康和财产安全，可能需要处理您的个人信息。
                </p>
                <p>
                  (4)为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息：为了公共利益，如新闻报道和舆论监督，可能在合理范围内处理您的个人信息。
                </p>
                <p>
                  (5)在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息：如果您已经公开了某些个人信息，或者这些信息已经合法公开，我们可能在合理范围内处理这些信息。
                </p>
                <p>(6)法律、行政法规规定的其他情形：其他法律法规规定的情形。</p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.5 信息收集</h3>
              <div class="content-box">
                <p>我们会按照以下两种方式收集您的个人信息：</p>
                <p>您主动提供：</p>
                <p>
                  当您使用产品和服务时，您可能需要提供一些基本信息，如电话号码、电子邮件等。
                </p>
                <p>
                  在使用过程中，您可能会主动上传文字、图片、音频、视频或其他文件等内容。
                </p>
                <p>
                  当您向我们反馈问题、提出建议、投诉或请求客服支持时，您可能会提供相关的个人信息。
                </p>
                <p>我们主动收集：</p>
                <p>服务器会自动记录您的使用情况，包括访问时间、IP地址等。</p>
                <p>
                  我们可能会使用Cookie和类似技术来了解您的使用习惯，以便提供更个性化的服务。
                </p>
                <p>
                  以上信息收集的类型、数量、用途及保存期限的详细清单，请参阅<span
                    class="bold-text"
                    >《隐私政策》“一、我们如何收集和使用您的个人信息”</span
                  >。关于Cookie和同类技术的详细说明，请参阅<span
                    class="bold-text"
                    >《隐私政策》“二、我们如何使用Cookie和同类技术”</span
                  >。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.6 个人信息收集与同意方式</h3>
              <div class="content-box">
                <p>我们将在以下场景征得您的同意后收集相应个人信息：</p>
                <p>
                  （1）注册账号时：您通过勾选《隐私政策》并点击"同意"的方式，授权我们收集您的手机号/邮箱用于账号注册；
                </p>
                <p>
                  （2）首次使用对话服务时：弹窗告知"我们将收集您输入的文字、图片、语音用于AI推理"，您点击"同意并继续"即视为授权；
                </p>
                <p>
                  （3）涉及敏感个人信息（如生物识别、身份证号等）时，我们会单独弹窗并获取您的明示同意；
                </p>
                <p>
                  （4）您可随时通过"设置-隐私-撤回授权"或联系客服撤回同意，撤回不影响此前基于同意的合法处理。
                </p>
                <p>
                  关于征得同意的具体规则及无需同意的法定例外情形，详见<span
                    class="bold-text"
                    >《隐私政策》“一、1.3征得授权同意的例外”</span
                  >。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.7 您的个人信息权利与行使方式</h3>
              <div class="content-box">
                <p>
                  按照中国相关法律法规，您对您的个人信息享有查阅、复制、更正、补充、删除的权利。您可通过以下方式行使：
                </p>
                <div class="table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th>权利类型</th>
                        <th>行使条件</th>
                        <th>行使途径</th>
                        <th>响应时限</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>查阅</td>
                        <td>已注册用户</td>
                        <td>产品内「头像/我的-账户信息」</td>
                        <td>实时</td>
                      </tr>
                      <tr>
                        <td>复制</td>
                        <td>已注册用户</td>
                        <td>邮件至客服邮箱申请</td>
                        <td>15个工作日</td>
                      </tr>
                      <tr>
                        <td>更正/补充</td>
                        <td>信息错误或不完整</td>
                        <td>产品内「头像/我的-账户信息」修改</td>
                        <td>实时</td>
                      </tr>
                      <tr>
                        <td>删除/注销</td>
                        <td>法定或约定情形</td>
                        <td>邮箱联系客服</td>
                        <td>15个工作日</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p>
                  我们将在收到您的请求后15个工作日内作出响应。如情形复杂，可延长至30个工作日，我们将告知延长期限及理由。
                </p>
                <p>
                  各项权利的详细行使条件、范围及流程，请参阅<span class="bold-text">《隐私政策》“五、您的权利”。</span>
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.8 关于人工智能生成合成内容的标识规则</h3>
              <div class="content-box">
                <p>
                  为遵守《人工智能生成合成内容标识办法》及GB
                  45438-2025《网络安全技术人工智能生成合成内容标识方法》等法律法规和国家标准，本服务对利用人工智能技术生成的内容添加相应标识。
                </p>
                <div class="sub-section">
                  <h4>1.8.1 默认标识规则</h4>
                  <div class="content-box">
                    <p>
                      除非您另行申请移除显式标识（见1.8.3），本服务默认对所有生成内容添加显式和隐式标识。
                    </p>
                    <p>
                      （1）显式标识：图片与视频内容：在生成内容右下角添加"AI生成"水印，文字高度不低于画面最短边长度的5%；交互式对话场景：在对话界面展示"内容由AI生成"提示信息。
                    </p>
                    <p>
                      （2）隐式标识：在生成内容文件元数据中嵌入不可感知的技术标识，用于内容溯源。隐式标识包括但不限于：生成时间、服务提供者标识、内容标识唯一编号等信息。
                    </p>
                  </div>
                </div>
                <div class="sub-section">
                  <h4>1.8.2 用户的标识义务</h4>
                  <div class="content-box">
                    <p>
                      您不得以任何方式移除、遮挡、篡改、隐藏或试图规避本服务默认添加的任何显式或隐式标识。如您将生成内容转发、分享或二次传播至其他平台或媒介，您应确保标识完整保留，或自行添加符合相关法律法规要求的标识。
                    </p>
                  </div>
                </div>
                <div class="sub-section">
                  <h4>1.8.3 申请移除显式标识的特殊约定</h4>
                  <div class="content-box">
                    <p>
                      如需获取不包含显式标识的内容，您须联系我们提交书面申请并同意以下条款：
                    </p>
                    <p>
                      （1）责任转移：您成为该内容后续使用与传播的责任主体，应自行添加符合法律法规要求的标识；
                    </p>
                    <p>
                      （2）使用限制：不得将移除显式标识的内容用于任何可能误导、欺骗公众或侵犯他人合法权益的用途；
                    </p>
                    <p>
                      （3）日志留存：我们将依法记录您的申请及操作日志，至少保存6个月；
                    </p>
                    <p>
                      （4）隐式标识仍保留于文件元数据中，不受移除显式标识申请的影响。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.9 信息保护</h3>
              <div class="content-box">
                <p>
                  中碳非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取合理可行的措施，尽力避免收集无关的用户信息。尽管我们已经按照相关法律法规要求采取了合理有效的安全措施，但由于技术限制和可能存在的恶意手段，我们不能保证百分之百的信息安全。请您了解并理解，我们所提供的系统和通信网络可能会受到我们无法控制的因素影响而出现问题。
                </p>
                <p>
                  关于信息保存地域、保存期限、安全保护措施及安全事件处理等详细内容，请参阅<span
                    class="bold-text"
                    >《隐私政策》“四、我们如何保存和保护您的个人信息”。</span
                  >
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.10 风险提示</h3>
              <div class="content-box">
                <p>
                  人工智能和机器学习是快速发展的研究领域。我们一直在努力改进我们的服务，使其更加准确、可靠、安全和有益。然而，鉴于机器学习的不确定性和概率性，使用我们的服务在某些情况下可能会产生不准确的输出结果，亦无法保证输出的时效性。此外，受限于技术，我们的输出也可能无法穷尽展示您想要的内容。
                </p>
                <p>因此，请您在使用服务时注意：</p>
                <p>
                  （1）请不要将输出视为唯一的事实来源或绝对真实信息，您需要自行评估内容的准确性和适用性。根据使用目的和场景，合理应用或分享，避免因错误或不适当的内容带来不良影响；
                </p>
                <p>
                  （2）输出不可以用来替代医疗、法律、金融、教育等领域的专业建议；
                </p>
                <p>
                  （3）不要直接使用生成内容作出可能对个人产生法律影响或其他重大影响的决定，例如关于个人的信用、教育、就业、住房、保险、法律、医疗或其他重要决策；
                </p>
                <p>
                  （4）输出不代表中碳的观点，仅供您参考，如果输出提及任何第三方产品或服务，这并不意味着该第三方认可该内容，或该第三方与中碳有关联。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.11 免责声明</h3>
              <div class="content-box">
                <p>
                  人工智能生成的内容可能存在不准确、不完整或错误之处，不代表真实情况，也不代表我们的观点或立场。您应当对生成内容自行甄别、审慎判断并谨慎使用，不应将其作为作出决策的唯一依据；由此产生的风险及后果由您自行承担。除法律法规另有强制性规定外，我们不对您因使用或依赖生成内容而产生的任何损失承担责任。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="account" class="policy-section">
          <h2>二、账号管理</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>2.1 注册</h3>
              <div class="content-box">
                <p>
                  您在使用本服务前，可通过中碳普惠云科技有限公司的官方联系方式申请账号，按要求填写真实、准确、合法、有效的相关信息，并确认同意本协议以及其他相关规则、政策。
                </p>
                <p>
                  您保证所提供的信息真实、准确、完整、合法、有效，并及时更新上述信息。如因您提供的信息不实或不完整导致任何损失或责任，由您自行承担。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>2.2 使用及转让</h3>
              <div class="content-box">
                <p>
                  注册成功后，您本人对您的账号享有合法使用权并对您账号项下的所有行为承担法律责任。您应妥善保管账号，不得以任何形式将账号擅自转让、出借、出租或提供给他人使用。
                </p>
                <p>
                  如因您未保管好账号，包括账号被盗窃或非法利用后未及时采取补救措施的，导致的任何损失或责任，由您自行承担。如您发现账号被盗用或存在安全漏洞，请立即通知我们。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>2.3 账户注销</h3>
              <div class="content-box">
                <p>
                  您有权随时联系我们申请注销账号。账号注销后，我们将按照法律法规要求删除或匿名化处理您的个人信息，具体流程请参见《隐私政策》相关章节。账号注销后，您将无法继续使用本服务，且相关数据可能无法恢复。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="rights" class="policy-section">
          <h2>三、用户行为规范</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>3.1 合规使用</h3>
              <div class="content-box">
                <p>您承诺不会利用本服务从事任何违法违规活动，包括但不限于：</p>
                <p>
                  （1）危害国家安全、泄露国家秘密，颠覆国家政权、破坏国家统一；
                </p>
                <p>（2）损害国家荣誉和利益；</p>
                <p>（3）煽动民族仇恨、民族歧视，破坏民族团结；</p>
                <p>（4）破坏国家宗教政策，宣扬邪教和封建迷信；</p>
                <p>（5）散布谣言，扰乱社会秩序，破坏社会稳定；</p>
                <p>（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；</p>
                <p>（7）侮辱或者诽谤他人，侵害他人合法权益；</p>
                <p>（8）含有法律、行政法规禁止的其他内容。</p>
                <p>
                  特别地：您不得利用本服务制作、复制、发布、传播任何违反法律法规、监管要求的信息，亦不得利用本服务从事任何损害国家利益、社会公共利益或他人合法权益的活动。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>3.2 禁止行为</h3>
              <div class="content-box">
                <p>您不得从事以下行为：</p>
                <p>（1）利用本服务侵害他人知识产权、商业秘密等合法权益；</p>
                <p>
                  （2）对服务进行反向工程、反向汇编、反编译，或者以其他方式尝试发现服务的源代码或算法；
                </p>
                <p>
                  （3）采用恶意手段干扰服务的正常运行，包括但不限于攻击、侵入服务器、超负荷使用等；
                </p>
                <p>（4）利用自动化工具批量注册账号、发送请求或获取数据；</p>
                <p>
                  （5）将本服务用于任何商业目的，未经书面授权不得转售、分发或商业化使用服务输出内容；
                </p>
                <p>
                  （6）通过恶意诱导、越狱提示词等方式试图获取违反本协议的输出内容。
                </p>
                <p>
                  （7）以任何形式（包括但不限于通过提示词诱导、恶意指令、角色设定、越狱攻击、投喂违规语料等方式）诱导、教唆本服务生成违反法律法规、监管要求或本协议约定的内容。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>3.3 输入责任</h3>
              <div class="content-box">
                <p>
                  您上传任何内容（包括但不限于正常输入、反馈或联系我们时提供的文字、语音、图片或其他格式的文件）时，请特别留意这些内容是否包含或涉及任何第三方的个人/企业信息或者涉密信息等不适当的信息。在提交此类信息前，您有责任确保已经获得了所有必要的合法授权，以避免无意中泄露他人隐私或者侵犯其合法权益。
                </p>
                <p>
                  您对您输入的所有内容承担全部责任，确保该等内容不侵犯任何第三方的合法权益。如因您上传的内容引发任何纠纷或法律责任，由您自行承担并赔偿由此给我们造成的全部损失。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="rules" class="policy-section">
          <h2>四、知识产权</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>4.1 平台权利</h3>
              <div class="content-box">
                <p>
                  本服务中包含的所有内容（包括但不限于软件、技术、程序、网页、文字、图片、音频、视频、图表、版面设计、电子文档等）的知识产权均归中碳普惠云科技有限公司所有（依法属于第三方的除外），受中华人民共和国著作权法、商标权、专利权等知识产权和其他权利的保护。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>4.2 用户内容权利</h3>
              <div class="content-box">
                <p>
                  在未侵害他人合法知识产权或其他权利并遵守本协议的前提下，您在法律允许的范围内，拥有对您输入和输出内容的知识产权、其他权利和对内容负责的义务。由于技术限制，我们无法保证其他用户的内容与您的内容完全不一致，不排除会出现输出内容雷同的情况，鉴于此，您对输出所享有的权利无法当然及于其他用户的内容。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>4.3 输出内容权利</h3>
              <div class="content-box">
                <p>关于输出内容的知识产权归属：</p>
                <p>
                  （1）您对基于您输入所产生的输出内容享有使用权，可在法律允许的范围内进行合理使用；
                </p>
                <p>
                  （2）为了提升服务质量，您授予我们一项免费的非独占许可，允许我们在法律允许的范围内将您的输入输出内容及反馈用于模型服务优化和技术改进；
                </p>
                <p>
                  （3）您理解并同意，由于大模型的概率特性，不同用户的相似输入可能产生相同或相似的输出结果。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="liability" class="policy-section">
          <h2>五、违约责任</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>5.1 违规处理</h3>
              <div class="content-box">
                <p>
                  您了解并同意，针对您违反本协议及相关法律法规的行为，我们可以独立判断，包括依据您的个人信息与行为数据或其他互动关系来综合认定，在无需通知的情况下，对您采取包括但不限于警示提醒、限期改正、限制账号功能、暂停使用、关闭账号、禁止重新注册、删除相关内容等处置措施。
                </p>
                <p>此外，我们还可以视违规情节采取以下一项或多项措施：</p>
                <p>（1）警示提醒；</p>
                <p>（2）限期改正；</p>
                <p>（3）限制账号功能；</p>
                <p>（4）暂停使用；</p>
                <p>（5）关闭账号；</p>
                <p>（6）禁止重新注册；</p>
                <p>（7）删除相关内容；</p>
                <p>（8）其他我们认为必要的措施。</p>
                <p>
                  我们有权公告处理结果，且有权根据实际情况决定是否恢复使用。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.2 赔偿责任</h3>
              <div class="content-box">
                <p>
                  您应当独立承担因您的违约行为导致的全部法律责任或第三方主张的任何索赔和要求。因此给我们造成任何损失的，您应当予以全部赔偿（包括我们维权所支出的诉讼费、仲裁费、律师费、公证费、公告费、鉴定费、差旅费、调查取证费、赔偿金、违约金、和解费用、行政处罚的罚金等）。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="liability2" class="policy-section">
          <h2>六、责任限制</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>6.1 不可抗力等原因：</h3>
              <div class="content-box">
                <p>
                  我们依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们不承担相应责任：
                </p>
                <p>
                  （1）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
                </p>
                <p>
                  （2）因电力供应故障、通讯网络故障等公共服务因素或移动通讯终端病毒或黑客攻击、系统不稳定等第三人因素；
                </p>
                <p>
                  （3）在已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>6.2 技术限制：</h3>
              <div class="content-box">
                <p>
                  由于本服务所依赖的技术和资源瓶颈，我们不对以下事项作出任何保证：
                </p>
                <p>（1）不保证本服务符合您的实际或特定需求；</p>
                <p>
                  （2）不保证本服务准确可靠、功能可用、及时、无错误、不受干扰、无中断、持续稳定、不存在任何故障；
                </p>
                <p>
                  （3）不保证本服务中的全部信息无瑕疵、无偏见、不侵权、完全合理；
                </p>
                <p>
                  （4）不保证本服务的代码、程序及其指向的内容的准确性、稳定性和完整性；
                </p>
                <p>
                  （5）不保证通过恶意诱导或其他违反本协议的使用方式所输出的内容与本服务运营主体的观点保持一致。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>6.3 损失限额</h3>
              <div class="content-box">
                <p>
                  若您遇到涉及借款、投融资、理财等财产相关的信息，以及账号密码或广告等内容，请您务必保持警惕并自行判断。对于您因上述情况遭受的任何损失，包括但不限于利润损失、商业信誉受损、资料丢失或其他有形或无形损失，我们不承担任何直接、间接、附带、衍生性或惩罚性的赔偿责任。除非法律法规另有明确规定，否则我们对您承担的全部责任，无论基于何种原因或方式，均不会超过您在使用本服务期间支付给我们的费用总额（如有）。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>6.4 内容审核</h3>
              <div class="content-box">
                <p>
                  我们有权根据本协议处理违法违规内容，但该权利并不构成我们的义务或承诺。我们无法保证能够及时发现或处理所有违法行为。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>6.5 权利转让</h3>
              <div class="content-box">
                <p>
                  我们保留将本条款下的权利或义务转让给任何关联公司、子公司或与本服务相关的任何业务继受者的权利。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="termination" class="policy-section">
          <h2>七、服务变更与终止</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>7.1 用户主动终止</h3>
              <div class="content-box">
                <p>
                  用户有权随时联系我们注销并终止服务。如果用户出现违反法律法规，违反本协议或平台规则，侵害公众、我们或者第三人合法权益的情况，我们会视情况主动终止服
                </p>
                <p>账号注销后，除法律法规要求保留的信息外，我们将删除或匿名化处理您的个人信息。</p>
              </div>
            </div>
            <div class="sub-section">
              <h3>7.2 平台终止服务</h3>
              <div class="content-box">
                <p>出现下列情形之一时，我们有权视情况终止向您提供服务：</p>
                <p>（1）用户违反法律法规的规定或本协议约定的；</p>
                <p>（2）用户侵害公众利益、我们或第三人合法权益的；</p>
                <p>（3）出于整体服务运营的需要。</p>
              </div>
            </div>
            <div class="sub-section">
              <h3>7.3 服务调整</h3>
              <div class="content-box">
                <p>
                  为了整体服务运营的需要，我们有权视具体情况决定服务/功能的设置与范围，有权修改、中断、中止或终止本服务。对于付费服务，如需终止将依法提前通知并协商处理已付费用。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="minors" class="policy-section">
          <h2>八、未成年人使用提示</h2>
          <div class="section-content">
            <div class="sub-section">
              <div class="content-box">
                <p>
                  未成年人应该在其监护人的监督指导下使用本服务，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好的上网习惯。
                </p>
                <p>未成年用户应当遵守《全国青少年网络文明公约》：</p>
                <p>要善于网上学习，不浏览不良信息；</p>
                <p>要诚实友好交流，不侮辱欺诈他人；</p>
                <p>要增强自护意识，不随意约会网友；</p>
                <p>要维护网络安全，不破坏网络秩序；</p>
                <p>要有益身心健康，不沉溺虚拟时空。</p>
                <p>
                  为更好地保护未成年人的隐私权益，请您务必严格遵守相关法律法规和用户使用规范，慎重上传包含未成年人信息或素材的内容。一经上传，即视为您同意我们在本服务中依法依规处理与该未成年人相关的内容。
                </p>
                <p>
                  关于未成年人个人信息保护的详细规则，请参阅《隐私政策》“六、我们如何处理未成年人的个人信息”。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="law" class="policy-section">
          <h2>九、法律适用与争议解决</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>9.1法律适用</h3>
              <div class="content-box">
                <p>
                  本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。
                </p>
              </div>
            </div>
          </div>
          <div class="section-content">
            <div class="sub-section">
              <h3>9.2争议解决</h3>
              <div class="content-box">
                <p>
                  若本协议的签订、履行或解释发生争议，双方应首先努力友好协商解决；协商不成时，任何一方均有权向中碳普惠云科技有限公司住所地有管辖权的法院起诉。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="others" class="policy-section">
          <h2>十、其他条款</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>10.1 条款的可分性与可执行性</h3>
              <div class="content-box">
                <p>
                  若本协议中任何一条款被认定为废止、无效或不可执行，该条款应被视为可分割的，不影响本协议其他条款的有效性及可执行性。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>10.2 权利保留</h3>
              <div class="content-box">
                <p>
                  我们延迟或暂不行使本协议项下的任何权利，并不应被视为对该权利的放弃。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>10.3 协议更新</h3>
              <div class="content-box">
                <p>
                  为持续优化服务体验并适应国家法律法规、政策调整、技术条件及产品功能等变化，我们可能会不定期地更新本协议。更新后的协议内容将构成本协议的组成部分，并通过页面公示、页面提示或信息推送等方式通知您。如您继续使用本服务，即表示您已同意接受更新后的本协议内容。如您对更新后的协议条款存有异议的，您有权停止登录或使用本服务。若您继续登录或使用本服务，即视为您认可并接受修改后的协议条款。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>10.4 权利转让</h3>
              <div class="content-box">
                <p>
                  我们保留将本协议项下的权利或义务转让给任何关联公司、子公司或与本服务相关的任何业务继受者的权利。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" class="policy-section">
          <h2>十一、投诉举报与联系我们</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>11.1 投诉举报途径</h3>
              <div class="content-box">
                <p>
                  如果您在使用本服务过程中有任何问题、意见或建议，或发现违法违规内容、违法不良信息，或您的合法权益（包括但不限于知识产权、个人信息、肖像权、名誉权等）受到侵害，欢迎通过发送电子邮件的方式投诉举报：
                </p>
                <p>邮件地址：customerservice@carbonneutrality-group.com</p>
              </div>
            </div>
            <div class="sub-section">
              <h3>11.2 反馈方式与时限</h3>
              <div class="content-box">
                <p>
                  我们将在收到您的投诉举报后15个工作日内予以处理并通过原途径反馈处理结果。涉及复杂事项可延长至30个工作日，我们将告知延长期限及理由。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>11.3 证据要求</h3>
              <div class="content-box">
                <p>
                  当您的合法权益受到侵害，投诉时需要按照法律规定提交您的真实身份信息以及构成侵权的初步证据。您可以通过发送邮件至customerservice@carbonneutrality-group.com与我们取得联系。我们会按照法律的规定，尽快处理您的请求。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer class="footer">
        <div class="bold-text">
          本协议由中碳普惠云科技有限公司所有，保留一切对此协议的解释权利。
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy-policy {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  font-size: 18px;
  color: #404040;
}

/* 内容区样式 */
.policy-container {
  min-width: 0;
  width: 100%;
}

.policy-header {
  text-align: center;
}

.policy-dates {
  color: #666;
  display: flex;
  gap: 16px;
  justify-content: center;
}

/* 章节样式 */
.policy-section {
  padding: 0 16px;
}
.policy-section h2 {
  position: relative;
  /* padding-left: 16px; */
}

.policy-section .section-content {
  margin-top: 24px;
}

.sub-section {
  margin-bottom: 20px;
}

.content-box {
  padding: 8px 0;
}

.notice-box {
  background: #fff7e6;
  border-left: 4px solid #ffa940;
  padding: 16px;
  margin: 16px 0;
}

.feature-list {
  margin: 16px 0;
}
.feature-list li {
  padding-left: 24px;
  margin: 8px 0;
}

.footer {
  text-align: center;
  margin: 16px;
}

h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
}

h2 {
  font-size: 24px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 20px 0 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

h3 {
  font-size: 20px;
  font-weight: 500;
  color: #262626;
  margin: 20px 0 10px;
}

h4 {
  font-size: 18px;
  font-weight: 500;
  color: #262626;
  margin: 20px 0 10px;
}

p {
  line-height: 1.8;
  text-indent: 2em;
  text-align: justify;
}
.bold-text {
  color: #111;
}

.table-wrapper {
  display: flex;
  justify-content: center;
  padding: 10px 30px;
}

table {
  width: 100%;
  border-collapse: collapse;
  line-height: 1.5;

  th,
  td {
    border: 1px solid #cad1db; /* 原生边框，颜色柔和 */
    text-align: left;
    vertical-align: middle;
  }
}
</style>
